const Billing = () => {
  return (<>Billing</>)
}

const BillingEdit = () => {
  return (<></>)
}

export {Billing, BillingEdit};